/**
 * Managed Kubernetes (OpenNebula, scope Internal.Opennebula.Kubernetes) on
 * gateway service code **s10015**. Mirrors the compute connector shape.
 *
 * Traffic goes through the @mgmt v3 strangler proxy (serviceApiV3): @mgmt enforces
 * service-access + write authz (Option C) then forwards to the legacy Ruby app at
 * /api/v2/services/:id/s10015/*. Same path shape as the s10003 compute proxy the
 * instance power-action already uses.
 *
 * Endpoints: /clusters, /clusters/:id (+ /nodes, /ingress, /kubeconfig,
 * /snapshots), /clusters/:id/nodepools (+ /:pid, /:pid/scale).
 */
import { serviceApiV3 } from '@/api/client';
import { unwrap } from '@/api/opennebula';

export const KUBERNETES_SCOPE = 'Internal.Opennebula.Kubernetes';
const S10015 = 's10015';
export const k8sPath = (serviceId: string, path: string) =>
  `/services/${serviceId}/${S10015}/${path.replace(/^\/+/, '')}`;

export const arr = <T,>(body: unknown, key: string): T[] =>
  Array.isArray(body) ? (body as T[]) : ((body as Record<string, unknown>)?.[key] as T[]) ?? [];

export const k8sKeys = {
  clusters: (s: string) => ['k8s', s, 'clusters'] as const,
  cluster: (s: string, id: string) => ['k8s', s, 'clusters', id] as const,
  nodes: (s: string, id: string) => ['k8s', s, 'clusters', id, 'nodes'] as const,
  pools: (s: string, id: string) => ['k8s', s, 'clusters', id, 'pools'] as const,
  poolMachines: (s: string, id: string, pid: string) => ['k8s', s, 'clusters', id, 'pools', pid, 'machines'] as const,
  metrics: (s: string, id: string) => ['k8s', s, 'clusters', id, 'metrics'] as const,
  ingress: (s: string, id: string) => ['k8s', s, 'clusters', id, 'ingress'] as const,
  snapshots: (s: string, id: string) => ['k8s', s, 'clusters', id, 'snapshots'] as const,
  logs: (s: string, id: string, node: string, svc: string) => ['k8s', s, 'clusters', id, 'logs', node, svc] as const,
  networks: (s: string) => ['k8s', s, 'networks'] as const,
  resources: (s: string) => ['k8s', s, 'resources'] as const,
  config: (s: string) => ['k8s', s, 'config'] as const,
};

// Re-exported as `serviceApi` so every k8s connector module routes through the v3
// proxy transparently (no per-call-site change).
export { serviceApiV3 as serviceApi, unwrap };
